import { render, staticRenderFns } from "./RoomMappingOthersSummary.vue?vue&type=template&id=8a5f9bc2&scoped=true"
import script from "./RoomMappingOthersSummary.vue?vue&type=script&lang=js"
export * from "./RoomMappingOthersSummary.vue?vue&type=script&lang=js"
import style0 from "./RoomMappingOthersSummary.vue?vue&type=style&index=0&id=8a5f9bc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5f9bc2",
  null
  
)

export default component.exports